export const dateFormat: string = 'MMM YYYY';

export default dateFormat;
